module.exports = __webpack_public_path__ + "img/client30.a66ca0c2.png";